import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'controller-dialog',
  templateUrl: 'controller-dialog.html',

})

export class ControllerDialogComponent {

  constructor(public dialogRef: MatDialogRef<ControllerDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  onCloseCancel() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/controller/controller-dialog.ts